var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "theme-analysis-chart" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.sortedTemas.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _vm._v("\n            Sin datos disponibles\n        "),
          ])
        : _c(
            "div",
            { staticClass: "bars-list" },
            _vm._l(_vm.sortedTemas, function (tema) {
              return _c("div", { key: tema.nombre, staticClass: "bar-row" }, [
                _c(
                  "div",
                  { staticClass: "bar-label", attrs: { title: tema.nombre } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(tema.nombre) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bar-track" }, [
                  tema.pendiente > 0
                    ? _c("div", {
                        staticClass: "bar-segment seg-pending",
                        style: {
                          width: _vm.pct(tema.pendiente, _vm.maxTotal) + "%",
                        },
                        attrs: { title: `Pendiente: ${tema.pendiente}` },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  tema.en_curso > 0
                    ? _c("div", {
                        staticClass: "bar-segment seg-progress",
                        style: {
                          width: _vm.pct(tema.en_curso, _vm.maxTotal) + "%",
                        },
                        attrs: { title: `En curso: ${tema.en_curso}` },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  tema.resuelto > 0
                    ? _c("div", {
                        staticClass: "bar-segment seg-done",
                        style: {
                          width: _vm.pct(tema.resuelto, _vm.maxTotal) + "%",
                        },
                        attrs: { title: `Resuelto: ${tema.resuelto}` },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bar-total" }, [
                  _vm._v(_vm._s(_vm.totalOf(tema))),
                ]),
              ])
            }),
            0
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-header" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-chart-bar text-warning" }),
        _vm._v(" Análisis por\n                Tema\n            "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend" }, [
        _c("span", { staticClass: "legend-item" }, [
          _c("span", {
            staticClass: "legend-dot",
            staticStyle: { background: "#ef4444" },
          }),
          _vm._v("\n                    Pendiente\n                "),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "legend-item" }, [
          _c("span", {
            staticClass: "legend-dot",
            staticStyle: { background: "#3b82f6" },
          }),
          _vm._v("\n                    En curso\n                "),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "legend-item" }, [
          _c("span", {
            staticClass: "legend-dot",
            staticStyle: { background: "#10b981" },
          }),
          _vm._v("\n                    Resuelto\n                "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }